import restApi from '../../http-common'
// import swal from 'sweetalert2'
import VueRouter from 'vue-router'
import swal from "sweetalert2";
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import COMPANIES from "../../services/ListCompany";
import Loc from "../../services/localization";
import AdminApi from "../../services/api";
import { getBaseApi, saveDynamicBaseApi, removeDynamicBaseApi } from "../../services/BaseApi";

const router = new VueRouter();
const apiService = new AdminApi();
const LocService = new Loc()
const savedCompanyCode = localStorage.getItem('COMPANY_CODE');

export default {
    name: 'login',
    data() {
        return {
            locale: LocService,
            backendError: null,
            companiesList : [],
            companyName: CONFIG_COMPANY.NAME,
            forceCodeOnLogin: CONFIG_COMPANY.FORCE_CODE_ON_LOGIN != null ? CONFIG_COMPANY.FORCE_CODE_ON_LOGIN : false,
            companyCode: savedCompanyCode != null && savedCompanyCode.length > 0 ? savedCompanyCode : null,
            companyCodeModel: '',
            companyCodeLoading: false,
            selectedCompany: null,
            model: {
                email: '',
                password: ''
            },
            // logoImage: require('../../assets/img/cfns_logo.png')
            logoImage: null//require('../../assets/img/cfns_logo.png')
        }
    },
    methods: {
        detectAgent:detectAgent,
        getConfig:getConfig,
        getCompanyList:getCompanyList,
        getBaseUrl:getBaseUrl,
        submitCompanyCode: submitCompanyCode,
        chooseCompany: chooseCompany,

        onTextChange(){
            this.backendError = null
        },

        keymonitor(event) {
            if(event.key === 'Enter') {
                this.login();
            }
        },

        companyCodeKeymonitor(event) {
            if(event.key === 'Enter') {
                this.submitCompanyCode();
            }
        },

        login() {
            let app = this;
            apiService.signIn(app.model)
                .then((response) => {
                    if (response.status === 200 && 'accessToken' in response.data) {
                        localStorage.setItem('ACCESS_TOKEN', response.data.accessToken);
                        localStorage.setItem('USER_ROLE', response.data.role);
                        localStorage.setItem('USERNAME', response.data.username);
                        localStorage.setItem('REST_OF_TRAININGS', response.data.restOfTrainings);
                        localStorage.setItem('GYM', response.data.gym);
                        localStorage.setItem('IS_MAIN_ADMIN', response.data.isMainAdmin);
                        if(response.data.isAcceptedTerms){
                            app.$router.push(CONFIG_COMPANY.HOME);
                        }else {
                            swal('Upozorenje', 'Morate da prihvatite uslove korišćenja ukoliko želite da trenirate.', 'warning');
                            window.location = '/#/accept-terms';
                        }
                    }
                })
                .catch((error) => {
                    // swal('Error', error, 'error')
                });
        }
    },
    components: {},
    watch: {
        'selectedCompany': function (newVal) {
            if(newVal != null){
                CONFIG_COMPANY.setCompany(newVal.name)
                this.companyName = CONFIG_COMPANY.NAME
            }
            this.logoImage = getBaseApi() + 'company-image/'+ newVal.name;
            this.getConfig(true);
        }
    },
    beforeMount() {
        if(localStorage.getItem('ACCESS_TOKEN') != null && localStorage.getItem('ACCESS_TOKEN').length > 0){
            this.$router.push(CONFIG_COMPANY.HOME);
        }
        if(this.forceCodeOnLogin){
            this.getBaseUrl().then(() => {
                prepareLoginPage.call(this);
            });
            return;
        }
        prepareLoginPage.call(this);
    },
    created() {

    }
}

function prepareLoginPage(){
        if(this.forceCodeOnLogin && this.companyCode != null && this.companyCode.length > 0){
            CONFIG_COMPANY.setCompany(this.companyCode);
            this.companyName = CONFIG_COMPANY.NAME;
            this.logoImage = getBaseApi() + 'company-image/'+CONFIG_COMPANY.NAME;
            this.getConfig(true);
            this.getCompanyList(this.companyCode, false, this.companyCode);
            return;
        }
        this.logoImage = getBaseApi() + 'company-image/'+CONFIG_COMPANY.NAME;

        if(this.forceCodeOnLogin && (this.companyCode == null || this.companyCode.length <= 0)){
            return;
        }
        this.getConfig(true);
        this.getCompanyList();
}

function chooseCompany(){
    localStorage.removeItem("COMPANY_CODE");
    this.companyCode = null;
    this.companyCodeModel = '';
    this.backendError = null;
    this.companiesList = [];
    this.selectedCompany = null;
}

function submitCompanyCode(){
    if(this.companyCodeLoading) return;

    let companyCodeTrim = this.companyCodeModel != null ? this.companyCodeModel.trim() : '';
    let companyCode = companyCodeTrim === 'global' ? 'testgym' : companyCodeTrim
    if(companyCode.length <= 0){
        this.backendError = LocService.t('label_enter_company_code');
        return;
    }

    let _self = this;
    _self.backendError = null;
    _self.companyCodeLoading = true;


    apiService.getCompanyConfiguration(companyCode)
        .then((response) => {
            if(response.data == null || response.data.id == null){
                _self.backendError = LocService.t('label_company_not_exist');
                _self.companyCodeLoading = false;
                return null;
            }
            session.saveConfig(response.data);
            session.setLastFetchConfig();
            localStorage.setItem('COMPANY_CODE', companyCode);
            _self.companyCode = companyCode;
            return apiService.getCompanyList(companyCode);
        })
        .then((response) => {
            if(response == null) return;
            _self.companiesList = response.data;
            _self.selectedCompany = getCompanyByName(_self.companiesList, companyCode);
            CONFIG_COMPANY.setCompany(companyCode);
            _self.companyName = CONFIG_COMPANY.NAME;
            _self.logoImage = getBaseApi() + 'company-image/'+CONFIG_COMPANY.NAME;
            _self.showDialogApp = session.getConfig().shouldAskToDownloadApps;
            _self.detectAgent();
            _self.companyCodeLoading = false;
        })
        .catch(error => {
            let errorData = error.response != null ? error.response.data : error.data;
            _self.backendError = errorData != null && errorData.localized_error_message != null
                ? errorData.localized_error_message
                : LocService.t('label_company_not_exist');
            _self.companyCodeLoading = false;
        })
}

function getBaseUrl(){
    return fetch('https://zakazi.fra1.digitaloceanspaces.com/a_base_config/baseUrl.json', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8',
        }
    })
        .then((response) => {
            if(response.status >= 300){
                removeDynamicBaseApi();
                return null;
            }
            return response.json();
        })
        .then((map) => {
            if(map == null) return;
            if(map.frontUrl != null){
                saveDynamicBaseApi(map.frontUrl.toString());
            }else {
                removeDynamicBaseApi();
            }
        })
        .catch(() => {

        })
}

function detectAgent() {
    if(!this.showDialogApp) return;
    let androidUrl = session.getConfig().googlePlay;
    let aAndroid = '<a href=\"' + androidUrl +'\">';
    let iosUrl = session.getConfig().appStore;
    let aios = '<a href=\"' + iosUrl +'\">';
    if(navigator.userAgent.toString().includes("Android")){
        swal({
            title: LocService.t("label_download_app"),
            html : '<html><div class="foo">' +
                '<br>' +
                aAndroid +
                '<div class="dialog-google-play"></div>'+
                '</a>' +
                '<br>'+
                // '<a><u>Ne sada</u></a>'+
                '</div></html>',
            text: "",
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: LocService.t("label_not_now"),
            customClass: 'swal2-warning'
        }).then(function () {

        });
    }else if(navigator.userAgent.toString().includes("iPhone")){
        swal({
            title: LocService.t("label_download_app"),
            html : '<html><div class="foo">' +
                '<br>' +
                aios +
                '<div class="dialog-app-store"></div>'+
                '</a>' +
                '<br>'+
                // '<a><u>Ne sada</u></a>'+
                '</div></html>',
            text: "",
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: LocService.t("label_not_now"),
            customClass: 'swal2-warning'
        }).then(function () {

        });
    }
}

function getConfig(force){
    if(!session.shouldFetchConfig() && force === false) {
        this.showDialogApp = session.getConfig().shouldAskToDownloadApps
        this.detectAgent()
        return;
    }
    let _self = this;
    apiService.getCompanyConfiguration(CONFIG_COMPANY.NAME)
        .then((response) => {
            session.saveConfig(response.data)
            session.setLastFetchConfig();
            _self.showDialogApp = session.getConfig().shouldAskToDownloadApps
            _self.detectAgent()
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function getCompanyByName(companiesList, name){
    if(companiesList == null || name == null) return null;
    for(let i = 0; i < companiesList.length; i++){
        if(companiesList[i].name === name){
            return companiesList[i];
        }
    }
    return null;
}

function getCompanyList(companyName, selectFirst, preselectName){
    let _self = this;
    let name = companyName != null ? companyName : CONFIG_COMPANY.NAME;
    apiService.getCompanyList(name)
        .then((response) => {
            _self.companiesList = response.data;
            let preselectedCompany = getCompanyByName(_self.companiesList, preselectName);
            if(preselectedCompany != null){
                _self.selectedCompany = preselectedCompany;
            }else if(selectFirst !== false && _self.companiesList.length > 0){
                _self.selectedCompany = _self.companiesList[0]
            }
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}



// WEBPACK FOOTER //
// ./src/components/Account/Login.js